module.exports = __webpack_public_path__ + "static/img/041志愿者.8fbd5cb.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/picImgs/041志愿者.jpg
// module id = i/fk
// module chunks = 0